import { DateTime } from 'luxon';

import { CopilMonthApi } from '../api/models/copil-month-api';

export class CopilMonth
{
    month: number;
    year: number;
    status: number;
    planningDates: DateTime[];

    public static mapperFromApi (source: CopilMonthApi): CopilMonth
    {
        const copilMonth = new CopilMonth();

        copilMonth.month = source.month;
        copilMonth.year = source.year;
        copilMonth.status = source.status;

        if (source.planningDates)
        {
            copilMonth.planningDates = source.planningDates.map(d =>
                DateTime.fromISO(d)
            ) as DateTime[];
        }

        return copilMonth;
    }
}
